import "./AbTestStyles.css";
import { formatPercentage, dateFirestoreToReact } from "../../helpers";
import { Spinner } from "react-bootstrap";
import { useState } from "react";
import RecordingModal from "../reusables/Recording/RecordingModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AbTestStep5 = ({ selectedTest, elementsNew, results, goals }) => {
  const navigate = useNavigate();
  const [recordingModalOpen, setRecordingModalOpen] = useState(false);

  if (!selectedTest || !results) {
    return (
      <div className="w-100 vhc mt-50">
        <Spinner className="size-100"></Spinner>
      </div>
    );
  }

  const { aConversions, bConversions, aTotal, bTotal } = results;

  const aRate = (aConversions / aTotal) * 100;
  const bRate = (bConversions / bTotal) * 100;

  const hasNoResults =
    aConversions === 0 && bConversions === 0 && aTotal === 0 && bTotal === 0;
  const performance = hasNoResults ? 0 : ((aRate - bRate) / bRate) * 100;

  const { firstPart, secondPart, sign } = formatPercentage(performance);
  const fontColor = sign === "+" ? "fc-green" : "fc-red";
  const outcome = sign === "+" ? "better" : "worse";

  const goalName =
    goals.find((goal) => goal.id === selectedTest.goalId)?.label ||
    "Invalid goal";

  const Comparison = () => {
    return (
      <>
        <div className="mb-32 fs-16 fw-500 fc-black2">
          The new version is performing{" "}
          <span className="fw-700 underline-4">
            {sign}
            {firstPart}% {outcome} on {goalName}
          </span>
        </div>
        <div className="abtest-version-comparison-container mb-50">
          <div className="abtest-version-comparison-container">
            <div className="w-50">
              <div className="d-flex">
                <div className="abtest-version-tab new mr-24">New version</div>
                <div className={`${fontColor} fw-900 fs-20 mt-8`}>
                  {sign}
                  {firstPart}%
                </div>
              </div>
              <img
                className="abtest-version-comparison-item abtest-img-limit"
                src={selectedTest.screenshotNew ?? ""}
              ></img>
            </div>
            <div className="w-50">
              <div className="d-flex min-content">
                <div className="abtest-version-tab original mr-24">
                  Original version
                </div>
              </div>
              <img
                className="abtest-version-comparison-item abtest-img-limit"
                src={selectedTest.screenshotOriginal ?? ""}
              ></img>
            </div>
          </div>
        </div>
      </>
    );
  };

  const GoDeeper = () => {
    return (
      <>
        <div className="fw-700 fs-18 fc-black mb-32">Go deeper</div>
        <div>
          {results?.replay && (
            <div
              className="abtest-go-deeper fw-700 fvc"
              onClick={() => {
                setRecordingModalOpen(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="fs-16 fc-black">
                Watch how visitors interact with the new version
              </div>
              <div className="btn-base btn-nonary fs-1334 fw-700 vhc">
                <i className="fa-regular fa-play mr-8 fs-18"></i>
                Play Recording
              </div>
            </div>
          )}
          <div
            className="abtest-go-deeper fw-700 fvc"
            onClick={() => {
              if (selectedTest.screenshotNew && elementsNew?.length) {
                navigate("/funnels/view/", {
                  state: {
                    test: {
                      name: selectedTest.name,
                      screenshotNew: selectedTest.screenshotNew,
                      elementsNew: elementsNew,
                      endDate: dateFirestoreToReact(selectedTest.endDate),
                      startDate: dateFirestoreToReact(selectedTest.startDate),
                      url: selectedTest.url,
                      device: selectedTest.device,
                      goalId: selectedTest.goalId,
                    },
                  },
                });
              } else {
                toast.warn(
                  "No heatmap data available for the new version yet.",
                );
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="fs-16 fc-black">
              See the heatmap of the new version
            </div>
            <div className="btn-base btn-nonary fs-1334 fw-700 vhc">
              <i className="fa-regular fa-fire-flame-curved mr-8 fs-18"></i>
              Show Heatmap
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="mb-100">
      {hasNoResults && (
        <div className="abtest-info-block mb-50">
          This test has no results. Perhaps it was cancelled early.
        </div>
      )}
      <div className="mt-50 mb-20 fw-700 fs-24 fc-black2">Result</div>
      <Comparison />
      <GoDeeper />
      {results?.replay && recordingModalOpen && (
        <RecordingModal
          isOpen={recordingModalOpen}
          onRequestClose={() => {
            setRecordingModalOpen(false);
          }}
          title={"View A/B Test Recording"}
          replay={results?.replay}
          overlayClassName="modal-overlay-blue"
        />
      )}
    </div>
  );
};

export default AbTestStep5;
